export const QUESTIONNAIRE_SECTION_COLORS = [
  'var(--portal-color-section-1)',
  'var(--portal-color-section-2)',
  'var(--portal-color-section-3)',
  'var(--portal-color-section-4)',
  'var(--portal-color-section-5)',
] as const;

export const BRAND_PRIMARY = 'var(--portal-color-primary)';
export const BRAND_MID = 'var(--portal-color-primary-strong)';
